import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Tag, Select, DatePicker, notification } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { franchises57ClientsOptions } from "../../constants/Customer";
import dayjs from "dayjs";
const { Text } = Typography;
const { RangePicker } = DatePicker;

const PsiJobInnactiveReport = () => {
	const [loading, setLoading] = useState(true);
	const [jobList, setJobList] = useState([]);
	const [franchise, setFranchise] = useState("57Concrete");
	const [psis, setPsis] = useState([]);
	const [psi, setPsi] = useState("All");
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "mixDesign",
			key: "mixDesign",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Scheduled Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Job Status",
			dataIndex: "jobStatus",
			key: "jobStatus",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag color={value === "57Concrete" ? "green" : "cyan"}>{value}</Tag>
				);
			},
		},
	];

	useEffect(() => {
		getPsis();
	}, [franchise]);

	useEffect(() => {
		getProductList();
	}, [startDate, endDate, psi, franchise]);

	const getPsis = async () => {
		const url = api + `/psi/list/${franchise}/innactive`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					value: "All",
					label: "All",
				},
			];

			data.map((item) => {
				list.push({
					value: item._id,
					label: item.psi,
				});
			});
			setPsis(list);
		} catch (err) {
			console.error(err.message);
		}
	};

	const getProductList = async () => {
		try {
			setLoading(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const url =
				api +
				`/job/get/psi/innactive/${psi}/${franchise}?startDate=${start}&endDate=${end}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						jobId: item.number,
						mixDesign: item.psiId.psi,
						seller: item.seller.name,
						plant: item.plant.name,
						jobStatus: item.jobStatus,
						date: Intl.DateTimeFormat("en-US").format(
							new Date(item.scheduledDate)
						),
						franchise: item.franchise || "57Concrete",
					});
				});
				setJobList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return <CustomTable columns={columns} data={jobList} />;
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangeFranchise = (value) => {
		setFranchise(value);
		setPsi("All");
	};

	const RenderSearch = () => (
		<Flex gap={"large"}>
			<RangePicker
				defaultValue={[
					dayjs(startDate, "MM/DD/YYYY"),
					dayjs(endDate, "MM/DD/YYYY"),
				]}
				onChange={onRangeChange}
				format={"MM/DD/YYYY"}
				size="large"
				disabled={loading}
				allowClear={false}
			/>
			<Select
				showSearch
				placeholder={`Select franchise`}
				optionFilterProp="children"
				size="large"
				onChange={onChangeFranchise}
				filterOption={filterOption}
				options={franchises57ClientsOptions}
				disabled={loading}
				defaultValue={"57Concrete"}
				value={franchise}
				style={{
					width: 200,
				}}
				allowClear={false}
			/>
			<Select
				showSearch
				placeholder={`Select psi`}
				optionFilterProp="children"
				size="large"
				onChange={(value) => setPsi(value)}
				filterOption={filterOption}
				options={psis}
				disabled={loading}
				defaultValue={"All"}
				value={psi}
				style={{
					width: 200,
				}}
				allowClear={false}
			/>
		</Flex>
	);

	return (
		<Layout title="Jobs With Psi Innactive" description="Report">
			<Flex vertical gap={"large"}>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default PsiJobInnactiveReport;
